// import Lang from 'lang.js'
import { numberFormater } from '../utility'
import TopBar  from '../TopBar.vue'
import ContactModal  from '../modals/ContactModal.vue'
import Contact from '../components/Contact.vue'
import DebugToolsModal from '../modals/DebugToolsModal.vue'
import StoreBusVue from './StoreBus.vue'
import VueI18n from 'vue-i18n'
import messages from '../config/lang/ui'

Vue.use(VueI18n)

// *** VUE GLOBAL SETTINGS *** //
window.EventBus = new Vue()
const StoreBus = new Vue(StoreBusVue)

Vue.prototype.$event = window.EventBus
Vue.prototype.$store = StoreBus

// Ready translated locale messages
const i18n = new VueI18n({
    locale: window.Laravel.config.locale, // set locale
    messages, // set locale messages
})

/* global-mixin */
Vue.mixin({
    i18n,
    filters: {
        numberFormater
    },
    methods: {
        numberFormater
    },
})

// *** Vue-Components *** //
//Contact Form
window.CONTACTVUE = Vue.component('contact', Contact)

window.contactFormulaModal = new Vue(ContactModal)

if($('#contact-front-page').length) {
    new Vue({el: "#contact-front-page"})
}

//DebugTools
const DebugToolsEl = document.getElementById('debug-tools-mountable')
if(DebugToolsEl) {new Vue(DebugToolsModal).$mount(DebugToolsEl)}


if(document.getElementById('header-vue')) {
    new Vue(TopBar)
}
